module.exports = __webpack_public_path__ + "media/store/images/bg-fatos-fe76925706b4afb75c6f579538f09297.png";